import { useStaticQuery, graphql } from 'gatsby';
import { IContentfulImage, IStaticContentfulImages } from 'src/types/contentful';

export interface IHoverableCardsSectionItem {
  avatarImage: IContentfulImage;
  logoImage: IContentfulImage;
  backgroundColor: string;
  text: string;
}

interface IHoverableCardsSectionItems {
  section: string;
  items: IHoverableCardsSectionItem[];
}

const useHoverableCardsSection = (): IHoverableCardsSectionItems[] => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      professional_1: contentfulAsset(contentful_id: { eq: "5vopwwWyTzle5SCiF9lOd7" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_1_logo: contentfulAsset(contentful_id: { eq: "2YXDTogRzgeOxYI3S7QOEv" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_2: contentfulAsset(contentful_id: { eq: "3NLgAoLjTWBbzWcWg46Kkk" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_2_logo: contentfulAsset(contentful_id: { eq: "20sBHWk7LfGS2rRStQdKtn" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_3: contentfulAsset(contentful_id: { eq: "1rqzfXD0CkXPWAB3SIPeiv" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_3_logo: contentfulAsset(contentful_id: { eq: "7qaFOYY5udmK3USbR4YxOY" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_4: contentfulAsset(contentful_id: { eq: "7ztpJsITtQIVo0lGTIfNNR" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      professional_4_logo: contentfulAsset(contentful_id: { eq: "3rAv97MNYNQ00it0keSOEh" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }

      personal_1: contentfulAsset(contentful_id: { eq: "6EybB8cucB8854zbuRElCj" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_1_logo: contentfulAsset(contentful_id: { eq: "75JS1yL2ML1lvQZkP0Q0iR" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_2: contentfulAsset(contentful_id: { eq: "OvwDhYI4usmPCjpAEl7jV" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_2_logo: contentfulAsset(contentful_id: { eq: "5j1eutnR3bpbFkffbwRPXd" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_3: contentfulAsset(contentful_id: { eq: "5tFM8FtHjdEPhKDfmkKBT4" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_3_logo: contentfulAsset(contentful_id: { eq: "1YKYUYefU5gBBxpdKMsCtr" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_4: contentfulAsset(contentful_id: { eq: "5vUQWDwWXQ9R0VAkBgjo2p" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      personal_4_logo: contentfulAsset(contentful_id: { eq: "6y4uu80GoNyYnETI8G3aUj" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }

      health_1: contentfulAsset(contentful_id: { eq: "7eQX5qKCRMh7U1caSKKlME" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_1_logo: contentfulAsset(contentful_id: { eq: "flhkcbhk1VxCZRzAJ9dAA" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_2: contentfulAsset(contentful_id: { eq: "ysjxr4mXLmG1n0FRmyOdO" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_2_logo: contentfulAsset(contentful_id: { eq: "EJksTI64MXxzu9Txo3DkT" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_3: contentfulAsset(contentful_id: { eq: "7mMXTCvanI1Fn9dpli57Cp" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_3_logo: contentfulAsset(contentful_id: { eq: "4tCxViqLpdgxzEgcv0OmVO" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_4: contentfulAsset(contentful_id: { eq: "51s8MzehacjC9qAoEc3rLg" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      health_4_logo: contentfulAsset(contentful_id: { eq: "3RvtT4btmCe0mViaDbn0Ti" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }

      brands_1: contentfulAsset(contentful_id: { eq: "5lePP3cmsra2RSiyRxP1Cf" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_1_logo: contentfulAsset(contentful_id: { eq: "2hboQSlSuGKyzX0cHrIdYo" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_2: contentfulAsset(contentful_id: { eq: "3m2klWOf0OvjamTB8qXJNe" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_2_logo: contentfulAsset(contentful_id: { eq: "1k87R6r8iTomznmJfIvawp" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_3: contentfulAsset(contentful_id: { eq: "8To4tEXWuw1bwc8IMeuRq" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_3_logo: contentfulAsset(contentful_id: { eq: "64l8wOldqUFfveotmh8mns" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_4: contentfulAsset(contentful_id: { eq: "3tYmOP1kA8rC225lOZf0Md" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      brands_4_logo: contentfulAsset(contentful_id: { eq: "6jogxNmzxE1GYGZKgjGXBz" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }

      nonprofit_1: contentfulAsset(contentful_id: { eq: "xbv26FW4ekJbhrKYReBqn" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_1_logo: contentfulAsset(contentful_id: { eq: "2DnCPFhgjbcqxvLn0nyK0w" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_2: contentfulAsset(contentful_id: { eq: "2Zaipu4iqVoZlFpiwOdKtV" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_2_logo: contentfulAsset(contentful_id: { eq: "2Or4NjCFKTLQ4oqLvrZwpQ" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_3: contentfulAsset(contentful_id: { eq: "mRtBecWNwzusZvk9KuPnK" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_3_logo: contentfulAsset(contentful_id: { eq: "2TrTvpkQwYsljnhzGA64SJ" }) {
        gatsbyImageData(width: 300, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_4: contentfulAsset(contentful_id: { eq: "3NSk2095A4DQGFHSRvfBoZ" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      nonprofit_4_logo: contentfulAsset(contentful_id: { eq: "593nfHNDBjh7z6tDAq9GH6" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  const professionalItems = [
    {
      avatarImage: images.professional_1,
      logoImage: images.professional_1_logo,
      backgroundColor: '#BEA2BC',
      text: 'Leadership Accountability Academy',
    },
    {
      avatarImage: images.professional_2,
      logoImage: images.professional_2_logo,
      backgroundColor: '#AE8BAB',
      text: 'Category Design Academy',
    },
    {
      avatarImage: images.professional_3,
      logoImage: images.professional_3_logo,
      backgroundColor: '#BEA2BC',
      text: 'Cheese State University',
    },
    {
      avatarImage: images.professional_4,
      logoImage: images.professional_4_logo,
      backgroundColor: '#AE8BAB',
      text: 'M5 Entrepreneurs',
    },
  ];

  const personalItems = [
    {
      avatarImage: images.personal_1,
      logoImage: images.personal_1_logo,
      backgroundColor: '#356c9a',
      text: 'Dream Club',
    },
    {
      avatarImage: images.personal_2,
      logoImage: images.personal_2_logo,
      backgroundColor: '#3C81B7',
      text: 'Tony Robbins Arena',
    },
    {
      avatarImage: images.personal_3,
      logoImage: images.personal_3_logo,
      backgroundColor: '#6199c4',
      text: 'LO sister',
    },
    {
      avatarImage: images.personal_4,
      logoImage: images.personal_4_logo,
      backgroundColor: '#3C81B7',
      text: 'Launch by Mel Robbins',
    },
  ];

  const healthItems = [
    {
      avatarImage: images.health_1,
      logoImage: images.health_1_logo,
      backgroundColor: '#E5A318',
      text: 'LoveLife With Matthew Hussey',
    },
    {
      avatarImage: images.health_2,
      logoImage: images.health_2_logo,
      backgroundColor: '#E7A928',
      text: 'Mindbody One',
    },
    {
      avatarImage: images.health_3,
      logoImage: images.health_3_logo,
      backgroundColor: '#E5A318',
      text: 'The Luckiest Club',
    },
    {
      avatarImage: images.health_4,
      logoImage: images.health_4_logo,
      backgroundColor: '#E7A928',
      text: 'The Journey of Intrinsic Health',
    },
  ];

  const brandsItems = [
    {
      avatarImage: images.brands_1,
      logoImage: images.brands_1_logo,
      backgroundColor: '#007D7D',
      text: 'TED-Ed',
    },
    {
      avatarImage: images.brands_2,
      logoImage: images.brands_2_logo,
      backgroundColor: '#339797',
      text: 'BODi Partners',
    },
    {
      avatarImage: images.brands_3,
      logoImage: images.brands_3_logo,
      backgroundColor: '#007D7D',
      text: 'The PlanetarySociety',
    },
    {
      avatarImage: images.brands_4,
      logoImage: images.brands_4_logo,
      backgroundColor: '#339797',
      text: 'Inc. 5000',
    },
  ];

  const nonProfitsItems = [
    {
      avatarImage: images.nonprofit_1,
      logoImage: images.nonprofit_1_logo,
      backgroundColor: '#d4753c',
      text: 'Beyond Type 1',
    },
    {
      avatarImage: images.nonprofit_2,
      logoImage: images.nonprofit_2_logo,
      backgroundColor: '#da8857',
      text: 'Dress for Success',
    },
    {
      avatarImage: images.nonprofit_3,
      logoImage: images.nonprofit_3_logo,
      backgroundColor: '#d16a2d',
      text: 'MiMentor',
    },
    {
      avatarImage: images.nonprofit_4,
      logoImage: images.nonprofit_4_logo,
      backgroundColor: '#d4753c',
      text: 'YWCA',
    },
  ];

  const items = [
    {
      section: 'Professional Development',
      items: professionalItems,
    },
    {
      section: 'Personal Development',
      items: personalItems,
    },
    {
      section: 'Health & Wellness',
      items: healthItems,
    },
    {
      section: 'Brands',
      items: brandsItems,
    },
    {
      section: 'Non-Profit',
      items: nonProfitsItems,
    },
  ];

  return items;
};

export default useHoverableCardsSection;
